"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

require("./TaskMultiChoice.scss");

var _react2 = require("@wwnds/react");

var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback"));

var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback"));

var _CompletedContext = require("../CompletedContext");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // import Form from 'react-bootstrap/Form'


function shuffle(a) {
  for (var i = a.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref = [a[j], a[i]];
    a[i] = _ref[0];
    a[j] = _ref[1];
  }

  return a;
}

var TaskMultiChoice = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskMultiChoice, _Component);

  var _super = (0, _createSuper2.default)(TaskMultiChoice);

  function TaskMultiChoice(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskMultiChoice);
    _this = _super.call(this, props);

    _this.handleSubmit = function (e) {
      e.preventDefault();

      if (typeof _this.props.correct === "object" && _this.props.correct.includes) {
        _this.setState({
          showFeedback: true,
          completed: _this.props.correct.includes(_this.state.indexMap[_this.state.selected])
        });
      } else {
        _this.setState({
          showFeedback: true,
          completed: _this.props.correct === _this.state.indexMap[_this.state.selected]
        });
      }
    };

    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = false;
      _this.state.selected = null;
      _this.state.showFeedback = false;
      _this.state.indexMap = [];

      for (var i = 0; i < _this.props.choices.length; i++) {
        _this.state.indexMap[i] = i;
      }

      if (_this.props.randomize) {
        shuffle(_this.state.indexMap);
      }
    }

    console.log("task constructed", _this.state);
    return _this;
  }

  (0, _createClass2.default)(TaskMultiChoice, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.correct !== this.state.correct || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i]; // Keep our stored state synchronized

        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      console.log("task mount", this.state); // Notify the parent of our completion status

      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        key: this.props.key,
        className: "task task-multi-choice"
      }, /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement(_react2.RadioGroup, {
        name: "fruit"
      }, this.props.choices.map(function (v, k) {
        v = _this3.props.choices[_this3.state.indexMap[k]];
        return /*#__PURE__*/_react.default.createElement(_react2.Radio, {
          onChange: function onChange() {
            _this3.setState({
              selected: k,
              showFeedback: false
            });
          },
          disabled: _this3.state.completed,
          checked: k === _this3.state.selected
        }, v);
      })), !this.state.completed && /*#__PURE__*/_react.default.createElement(_react2.Button, {
        className: "bdg-submit-button",
        style: {
          marginLeft: 'auto',
          display: 'block'
        },
        type: "submit",
        onClick: this.handleSubmit
      }, "Submit")), this.state.showFeedback && this.state.completed && this.props.feedback[this.state.indexMap[this.state.selected]] && /*#__PURE__*/_react.default.createElement(_AlertFeedback.default, {
        feedback: this.props.feedback[this.state.indexMap[this.state.selected]]
      }), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showFeedback && !this.state.completed,
        onHide: function onHide() {
          _this3.setState({
            showFeedback: false
          });
        }
      }, this.props.feedback[this.state.indexMap[this.state.selected]]));
    }
  }]);
  return TaskMultiChoice;
}(_react.Component);

exports.default = TaskMultiChoice;
TaskMultiChoice.contextType = _CompletedContext.CompletedContext;